
export let removeNull = val => val ?? "";
